import {
  root,
  addButton,
  searchByName,
  searchByMonth,
} from './usefulvariables.js'
import { fetchPeople } from './fetchData.js'
import { updatedLocalStorage, initialLocalStorage } from './localStorage.js'
import { displayData } from './displayData.js'
import { handleClickButtons } from './handleclick.js'
import { handleAddBtn } from './addBtn.js'

window.addEventListener('click', handleClickButtons)
root.addEventListener('updatedBirthday', updatedLocalStorage)
root.addEventListener('updatedBirthday', displayData)
initialLocalStorage()
addButton.addEventListener('click', handleAddBtn)
fetchPeople()
searchByName.addEventListener('input', () => displayData())
searchByMonth.addEventListener('change', () => displayData())
displayData()
